import { Component, OnInit } from '@angular/core';
import { AuthService, PeopleService } from '../../services';

@Component({
    templateUrl: './unauthorized.component.html',
    standalone: false
})
export class UnauthorizedComponent implements OnInit {
  constructor(private authService: AuthService, private peopleService: PeopleService) {}

  ngOnInit() {}

  logout() {
    this.authService.logout('inspectionbrowser').subscribe((data) => {
      this.peopleService.logout();
    });
  }
}
